/**
 * @generated SignedSource<<ebb07556405c2188141b9495b20266d4>>
 * @relayHash fbf771726e463887b742ac4d94e994f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9d351c6f302837de6d700036aed8b75ba3ee259f41dab092f3216999720404f5

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useDefaultAndSpaceClassificationLevelsQuery$variables = {
  spaceKey: string;
};
export type useDefaultAndSpaceClassificationLevelsQuery$data = {
  readonly classificationLevels: ReadonlyArray<{
    readonly color: string | null | undefined;
    readonly description: string | null | undefined;
    readonly guideline: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly order: number | null | undefined;
    readonly status: string;
  }> | null | undefined;
  readonly space: {
    readonly defaultClassificationLevelId: string | null | undefined;
    readonly id: string | null | undefined;
    readonly metadata: {
      readonly totalCurrentPages: AGG$Long;
    };
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type useDefaultAndSpaceClassificationLevelsQuery = {
  response: useDefaultAndSpaceClassificationLevelsQuery$data;
  variables: useDefaultAndSpaceClassificationLevelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "defaultClassificationLevelId"
      },
      {
        "concreteType": "SpaceMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "totalCurrentPages"
          }
        ]
      }
    ]
  },
  {
    "concreteType": "ContentDataClassificationLevel",
    "kind": "LinkedField",
    "name": "classificationLevels",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "order"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      },
      {
        "kind": "ScalarField",
        "name": "color"
      },
      {
        "kind": "ScalarField",
        "name": "description"
      },
      {
        "kind": "ScalarField",
        "name": "guideline"
      },
      (v2/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useDefaultAndSpaceClassificationLevelsQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDefaultAndSpaceClassificationLevelsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "fbf771726e463887b742ac4d94e994f9",
    "id": "9d351c6f302837de6d700036aed8b75ba3ee259f41dab092f3216999720404f5",
    "metadata": {},
    "name": "useDefaultAndSpaceClassificationLevelsQuery",
    "operationKind": "query",
    "text": "query useDefaultAndSpaceClassificationLevelsQuery($spaceKey:String!){space(key:$spaceKey){id,name,defaultClassificationLevelId,metadata{totalCurrentPages}},classificationLevels{id,order,status,color,description,guideline,name}}"
  }
};
})();

(node as any).hash = "0204187a42c76123b2656dae3e3e9f65";

export default node;
